export default {
	props: {
		dark: {
			type: Boolean,
		},
	},
};
